// https://www.sitepoint.com/javascript-design-patterns-singleton/
import get from 'lodash/get'
import Cookies from 'cookies-js'

/**
 * As of Jan 2020, the User login info is available of Page load,
 * Converting this to singleton so as not to invoke the function everytime it is needed
 */
class UserLoginDetails {
  constructor() {
    if (!UserLoginDetails.instance) {
      this.isUserSignedIn = false
      this.stickyLoggedIn = false
      this.dmcCookie = ''
      this.userName = ''
      this.email = ''

      if (typeof window !== 'undefined') {
        const { __PCLN_SI_PERSISTENCE__: pclnSI } = window

        if (pclnSI) {
          this.isUserSignedIn = pclnSI.isUserSignedIn
          this.stickyLoggedIn = get(
            pclnSI,
            'stickySignInData.passiveSignIn',
            false
          )
          this.userName = get(pclnSI, 'nameStatus.name', '')
          this.email = pclnSI?.decryptedEmailAddress ?? ''
        }
        this.dmcCookie = !!Cookies.get('dmc') && Cookies.get('dmc')
      }

      UserLoginDetails.instance = this
    }

    return UserLoginDetails.instance
  }
}

const userLoginData = new UserLoginDetails()
Object.freeze(userLoginData)

export { userLoginData }
